export const isSignedIn = (auth, emailLink = false) => {
    const user = auth.user;

    //console.log("isSignedIn", user, emailLink);

    if (user) {
        if (!emailLink && user.provider === "password") {
            return user.emailVerified;
        } else {
            return true;
        }
    } else {
        return false;
    }
};

// track user button click count in local storage, per button name
export const trackButtonClick = (buttonName) => {
    let count = localStorage.getItem(buttonName);
    count = count ? parseInt(count) + 1 : 1;
    localStorage.setItem(buttonName, count);
    return count;
};
